/*******************************************************************************
 * Copyright     : Copyright (c)  2019 Honeywell Inc. All rights reserved.
 *                 This work contains trade secrets and confidential materials
 *                 of Honeywell Inc., and its use or disclosure in whole or in
 *                 part without express written permission of Honeywell Inc.
 *                 is prohibited.
 *
 * Name          : sessionStorage.ts
 *
 * Project Title : Checkout
 *
 * Description   : Initial version
 *
 * Company       : Honeywell Technology Solutions , Hyderabad
 *
 * @Author       :  Sivateja (H267743)
 *
 * @Date         : Sept 13, 2019
 *
 * @Version      : Version 1.0
 *
 * By            : Sivateja (H267743)
 * On            : Sept 16, 2019
 * Description   : this will export the utility functions to store & retrieve the state to session storage (ASDS-1175)
 *
 ******************************************************************************/
import {legacy_createStore as createStore, applyMiddleware} from 'redux';
import thunk from 'redux-thunk';
import { composeWithDevTools } from 'redux-devtools-extension';
import appReducer from '../modules/checkout/redux/reducers/checkout-reducer';
import { loadState, saveState } from './sessionStorage';

import throttle from 'lodash/throttle';

/**
 * @author ASDS Team
 * @description Creates a store with initial data and returns.
 */
const configureStore = (initialState = loadState()) => {
    const middleWares = [thunk];
    const middlewareEnhancer = applyMiddleware(...middleWares)
    const enhancers = [middlewareEnhancer];
     const composedEnhancers = composeWithDevTools(...enhancers)

    const store = createStore(appReducer, initialState, composedEnhancers)

    /* writes the redux store data to local storage when ever there is change in store. */
    store.subscribe(throttle(() => {
        const prevState = loadState();
        saveState({...prevState,
            userValidationData : store.getState().userValidationData,
            selectAccount: store.getState().selectAccount
        });
    }, 1000));

    return store;
};

export default configureStore;
export const initialRootState = configureStore().getState();

